/** Modal side sheet (settings, debug). */
import { button, guardXrSelect, h } from './dom';
import { icon } from './icons';
import { nextId } from './controls';

export class Sheet {
  readonly el: HTMLElement;
  readonly body: HTMLElement;
  private readonly panel: HTMLElement;
  private readonly closeBtn: HTMLButtonElement;
  private opener: HTMLElement | null = null;
  onClose: (() => void) | null = null;

  constructor(title: string, opts: { onBack?: () => void; backLabel?: string } = {}) {
    const titleId = nextId('uz-sheet');
    this.closeBtn = button('uz-iconbtn', [icon('close')], () => this.close(), { 'aria-label': 'Schliessen' });
    const head = h('header', 'uz-sheet-head', null, [
      opts.onBack ? button('uz-iconbtn', [icon('back')], opts.onBack, { 'aria-label': opts.backLabel ?? 'Zurück' }) : null,
      h('h2', 'uz-sheet-title', { id: titleId }, [title]),
      this.closeBtn,
    ]);
    this.body = h('div', 'uz-sheet-body');
    this.panel = h('div', 'uz-sheet-panel', { role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': titleId, tabindex: -1 }, [head, this.body]);
    this.el = h('div', 'uz-sheet', { hidden: true }, [this.panel]);
    // Tap on the scrim closes.
    this.el.addEventListener('click', (e) => {
      if (e.target === this.el) this.close();
    });
    guardXrSelect(this.el);
  }

  get isOpen(): boolean {
    return !this.el.hidden;
  }

  open(opener?: HTMLElement | null): void {
    if (opener !== undefined) this.opener = opener;
    this.el.hidden = false;
    this.body.scrollTop = 0;
    this.panel.focus({ preventScroll: true });
  }

  /** Hide without restoring focus (used when switching between sheets). */
  hide(): void {
    this.el.hidden = true;
  }

  close(): void {
    if (this.el.hidden) return;
    this.el.hidden = true;
    const o = this.opener;
    this.opener = null;
    if (o && o.isConnected && !o.closest('[hidden]')) o.focus({ preventScroll: true });
    this.onClose?.();
  }
}
